<!--
 * @Description: 订单管理 新能源结算订单
 * @Author: Tina
 * @Date: 2023-07-28 09:46:08
 * @LastEditors: Tina
 * @LastEditTime: 2023-08-11 16:18:18
 -->
<template>
  <div class="settlement-order" @keyup.enter="enterSearch">
    <!-- <el-form class="table-search-bar" inline :model="handForm" ref="handForm">
      <el-form-item label="状态" prop="status">
        <el-select v-model="handForm.status" placeholder="请选择">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      </el-form-item>
    </el-form> -->
    <el-table
      :data="handData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="orderMain.orderCode"
        label="订单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.takeOrderNo"
        label="提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="协议编号"
        :formatter="agreementFormat"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.deptName"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.takeArea"
        label="发货区"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.stockOrgName"
        label="库存组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderItem.itemName"
        label="商品名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderItem.itemCode"
        label="商品编码"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.consumerName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="销售数量"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.itemNum}}{{scope.row.orderItem.itemUnit}}
        </template>
      </el-table-column>
      <el-table-column
        label="币种"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.orderItem.currencyType == '1'">CNY</span>
          <span v-else-if="scope.row.orderItem.currencyType == '2'">USD</span>
          <span v-else-if="scope.row.orderItem.currencyType == '3'">EUR</span>
          <span v-else>CNY</span>
        </template>
      </el-table-column>
      <el-table-column
        label="销售单价"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.discountedPrice}}
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="itemCount"
        label="运费"
        :show-overflow-tooltip="true">
      </el-table-column> -->
      <el-table-column
        label="销售总额"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderMain.payAmount}}
        </template>
      </el-table-column>
      <el-table-column
        label="销售净额"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.netSales ? scope.row.orderItem.netSales: '0'}}
        </template>
      </el-table-column>
      <el-table-column
        label="商品单价"
        :key="Math.random()"
        :show-overflow-tooltip="true"
        >
         <template slot-scope="scope">
          {{scope.row.orderItem.listPrice ? scope.row.orderItem.listPrice: '0'}}
        </template>
      </el-table-column>
      <el-table-column
        label="库存类型"
        :show-overflow-tooltip="true"
        >
         <template slot-scope="scope">
          {{scope.row.orderMain.stockType | filterType}}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderMain.belongDept"
        label="所属部门"
        :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
        prop="orderMain.plateNum"
        label="车牌号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.phoneNum"
        label="司机手机"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.driverName"
        label="司机姓名"
        :show-overflow-tooltip="true">
      </el-table-column> -->
      <el-table-column
        prop="orderMain.salesman"
        label="业务员"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.orderTime"
        label="新增时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.remarks"
        label="备注"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.businessDesc"
        label="业务说明"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.handlePerson"
        label="操作人"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        width="200"
        prop="syncSapStatusDetails"
        label="SAP同步状态"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.size" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.page">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'settlementOrder',
  data () {
    return {
      handForm: {
        status: ''
      },
      exportForm: {
        size: 1000,
        page: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ],
      typeOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待结算',
          value: 1
        }
      ]
    }
  },
  filters: {
    filterType (val) {
      const arr = {
        'normalInventory': '正常库存',
        'lockPlanInventory': '锁量库存',
        'outsourcedInventory': '外采库存'
      }
      return arr[val]
    }
  },
  computed: {
    ...mapState({
      handData: state => state.settlementOrder.list,
      listState: state => state.settlementOrder.listState
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.size
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getSettlementOrderList', 'exportNewEnergyOrder']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.handForm,
        pageNo: 1,
        isTransfer: '0',
        manualOrderType: 1,
        orderSettlementType: 1
      }
      this.getSettlementOrderList(params)
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.page = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.handData) || this.handData.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportNewEnergyOrder({ ...this.exportForm }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '石化新能源结算订单.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.getSettlementOrderList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getSettlementOrderList({ pageNo: val })
    },
    agreementFormat (row) {
      switch (row.orderMain.orderType) {
        case 1: // 零散
          return '-'
        case 2: // 协议
          return row.orderAgreements && row.orderAgreements.map(item => item.agreementCode).join('、')
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
